import { BusinessEntityInterface } from '@/components/compliances/types/BusinessEntityInterface'

export interface OldBusinessEntityInput {
  registered_company_name?: string | null
  company_no?: string | null
  vat_no?: string | null
  // Used for NL / DE markets
  is_vat_registered?: string | number | boolean | null
  // Used for all other markets
  is_vat_subject?: string | number | boolean | null
}

/**
 * Overlay the form input flashed back after a failed validation onto the
 * business entity loaded from the API.
 *
 * The business entity forms submit via a full-page reload and are rebuilt from
 * persisted data, so without this a validation failure would reset every field
 * (including the valid ones) to the stored — or, on first setup, empty — state.
 * `oldInput` is empty on a successful save, making this a no-op in that case.
 */
export default function applyOldInputToBusinessEntity(
  businessEntity: BusinessEntityInterface,
  oldInput: OldBusinessEntityInput | null | undefined,
): BusinessEntityInterface {
  if (!oldInput || Object.keys(oldInput).length === 0) {
    return businessEntity
  }

  const result = { ...businessEntity }

  if (oldInput.registered_company_name != null) {
    result.companyName = oldInput.registered_company_name
  }
  if (oldInput.company_no != null) {
    result.companyNo = oldInput.company_no
  }
  if (oldInput.vat_no != null) {
    result.taxNo = oldInput.vat_no
  }
  if (oldInput.is_vat_subject != null) {
    result.data = {
      ...result.data,
      is_vat_subject: [true, 1, '1'].includes(oldInput.is_vat_subject),
    }
  }
  if (oldInput.is_vat_registered != null) {
    result.data = {
      ...result.data,
      is_vat_registered: [true, 1, '1'].includes(oldInput.is_vat_registered),
    }
  }

  return result
}
